import { stringify } from 'query-string';
import React, { FC, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { useLocation, withRouter } from 'react-router-dom';

import { Button, Select, Theme } from '../../components';
import { useQuery } from '../../hooks/use-query';
import { AppAdminLink, FrontOfficeLink, GeneralLink, RestoAdminLink } from '../../models/Routes';

import './LoginAsUser.scss';

const USERS = [
  { email: 'app.admin1@ingka.ikea.com', redirectUrl: AppAdminLink.ROOT },
  { email: 'app.admin2@ingka.ikea.com', redirectUrl: AppAdminLink.ROOT },
  { email: 'resto.admin1@ingka.ikea.com', redirectUrl: RestoAdminLink.ROOT },
  { email: 'resto.admin2@ingka.ikea.com', redirectUrl: RestoAdminLink.ROOT },
  { email: 'resto.admin3@ingka.ikea.com', redirectUrl: RestoAdminLink.ROOT },
  { email: 'front.office.user1@ingka.ikea.com', redirectUrl: FrontOfficeLink.ROOT },
  { email: 'front.office.user2@ingka.ikea.com', redirectUrl: FrontOfficeLink.ROOT },
  { email: 'front.office.user3@ingka.ikea.com', redirectUrl: FrontOfficeLink.ROOT },
];

const LoginAsUser: FC<RouteComponentProps> = ({ history }) => {
  const [selectedEmail, setSelectedEmail] = useState<string>(USERS[0].email);
  const queryParams: URLSearchParams = useQuery(useLocation);

  const triggerLogin = async () => {
    if (queryParams && !queryParams.get('apikey')) {
      history.push(GeneralLink.ERROR + '?' + stringify({ message: 'You must provide an "apikey" query param' }));
    }
    const apikey = queryParams.get('apikey');
    const ssoLoginUrl = `${process.env.REACT_APP_API_HOST}auth/fake-login?${stringify({
      apikey,
      email: selectedEmail,
      redirectUrl: window.location.origin + USERS.find(u => u.email === selectedEmail)?.redirectUrl || FrontOfficeLink.ROOT,
    })}`;
    window.open(ssoLoginUrl, '_self');
  };

  return (
    <div className='login-as-user-view'>
      <Select options={USERS.map(u => ({ label: u.email, value: u.email }))} onChange={setSelectedEmail} value={selectedEmail} />
      <Button theme={Theme.SECONDARY} onClickCallback={triggerLogin}>
        Login
      </Button>
    </div>
  );
};

export default withRouter(LoginAsUser);
